<template>
  <div>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="formData" size="mini" label-width="90px">
        <div class="formItemBox">
          <el-form-item label="入库单号:">
            <el-input v-model="formData.instockNo" placeholder="请输入入库单号"></el-input>
          </el-form-item>
          <el-form-item label="车辆号牌:">
            <el-input v-model="formData.instockPlateNumber" placeholder="请输入车号"></el-input>
          </el-form-item>
          <el-form-item label="进仓单号:">
            <el-input v-model="formData.inWarehouseNo" placeholder="请输入进仓单号"></el-input>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select filterable clearable placeholder="请选择一级货主" v-model="formData.primaryCustomerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select clearable filterable placeholder="请选择二级货主" v-model="formData.customerTaxId">
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" clearable @change="productTypeChange" placeholder="请选择" filterable>
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" clearable @change='specificationChange' placeholder="请选择" filterable>
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" @change="modelChange" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="确认时间:" >
            <div style="display: flex;">
              <el-date-picker v-model="formData.confirmTimeStart" type="datetime" placeholder="选择确认时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              -
              <el-date-picker v-model="formData.confirmTimeEnd" placeholder="选择确认时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="到货方式:">
            <el-select v-model="formData.arrivalMethod" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item style="padding-left: 10px;">
          <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP00BB005" v-if="btnFlg[4]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP00BB006" v-if="btnFlg[5]">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" btnCode="00cP00BB007" v-if="btnFlg[6]">导出</el-button>
        </el-form-item>
        <div style="margin: 0 0 5px 10px">
          <span>总吨数:
            <span style="color:red">{{totalAllWeight}}</span>吨
          </span>
          <span>总件数:
            <span style="color:red">{{ totalNumber }}</span>件
          </span>
        </div>
      </el-form>
    </div>
    <div :style="{height:h}">
        <el-table
        border
        center
        bordersize="mini"
        :data="tableData"
        height="100%"
        style="width:100%"
        size="mini"
        highlight-current-row
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        @selection-change="selectGoods"
        >
          <el-table-column type="selection" align="center" width="40"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="50"></el-table-column>
          <el-table-column  prop="organizationName" label="仓库名称" width="140" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="confirmTime" label="确认时间" width="180" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="inWarehouseNo" label="进仓单号" width="220" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockTime" label="入库时间" width="180" ></el-table-column>
          <el-table-column prop="plateNumber" label="车船号" width="120" ></el-table-column>
          <el-table-column prop="shipForecastNo" label="预报编号" width="300" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="车号" width="150" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="220" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" width="220" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="110" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="120" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重（吨）" width="120" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="过磅净重时间" width="180" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="factoryWeight" label="出厂过磅净重（吨）" width="160" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" width="120" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockNo" label="入库单号" width="220" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="150" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="180" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" width="200" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="arrivalMethod" label="到货方式" align="center" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" width="110" ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center" width="150"></el-table-column>
          <el-table-column prop="createUser" label="创建人" align="center" width="130"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="180"></el-table-column>
          <el-table-column prop="confirmName" label="确认人" align="center" width="130"></el-table-column>

        </el-table>
    </div>
    <div class="pags" >
      <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          :page-sizes="[10,20,30,40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getRelationCustomer, getVirtualBalingList, JfgetConfirmedExpList, getConfirmedExpNumber } from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  name: 'JCRecord',
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      formData: {
        inWarehouseNo: '',
        instockNo: '',
        instockPlateNumber: '',
        productType: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerTaxId: '',
        customerTaxId: '',
        confirmTimeStart: '',
        confirmTimeEnd: '',
        arrivalMethod: ''
      },
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      btnArr: [
        // 入库记录
        '00cP00BB001',
        '00cP00BB002',
        '00cP00BB003',
        '00cP00BB004',
        // 进仓记录
        '00cP00BB005',
        '00cP00BB006',
        '00cP00BB007',
        // 出库记录
        '00cP00BB008',
        '00cP00BB009',
        '00cP00BB00A',
        '00cP00BB00B',
        // 转货记录
        '00cP00BB00C',
        '00cP00BB00D',
        '00cP00BB00E',
        '00cP00BB00F',
        // 移库记录
        '00cP00BB00G',
        '00cP00BB00H',
        '00cP00BB00I',
        // 亏涨记录
        '00cP00BB00J',
        '00cP00BB00K',
        '00cP00BB00L',
        // 删除记录
        '00cP00BB00M',
        '00cP00BB00N',
        '00cP00BB00O',
        // 撤销记录
        '00cP00BB00P',
        '00cP00BB00Q',
        '00cP00BB00R',
        // 入库过磅记录
        '00cP00BB00S',
        '00cP00BB00T',
        '00cP00BB00U',
        '00cP00BB00V',
        '00cP00BB00W',
        '00cP00BB00X',
        // 出库过磅记录
        '00cP00BB00Y',
        '00cP00BB00Z',
        '00cP00BB00a',
        '00cP00BB00b',
        '00cP00BB00c',
        '00cP00BB00d'
      ],
      btnFlg: [],
      tableData: [],
      HZData: [],
      h: 500,
      xuanzhongArr: null,
      daoruMark: false,
      isDisable1: false,
      selectListId: [],
      selectList: [],
      arrivalMethodData: [
        {
          value: '1',
          label: '火运'
        },
        {
          value: '2',
          label: '汽运'
        },
        {
          value: '3',
          label: '船运'
        }
      ],
      totalAllWeight: 0,
      totalNumber: 0
    }
  },
  props: {
    JCVisible: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getConfirmedExpNumber () {
      getConfirmedExpNumber(
        {
          inWarehouseNo: this.formData.inWarehouseNo,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          confirmTimeStart: this.formData.confirmTimeStart,
          confirmTimeEnd: this.formData.confirmTimeEnd,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          arrivalMethod: this.formData.arrivalMethod
        }
      )
        .then(res => {
          this.totalAllWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 列表查询
    JfgetConfirmedExpLists () {
      JfgetConfirmedExpList(
        {
          inWarehouseNo: this.formData.inWarehouseNo,
          instockNo: this.formData.instockNo,
          instockPlateNumber: this.formData.instockPlateNumber,
          productType: this.formData.productType,
          steelMillName: this.formData.steelMillName,
          specification: this.formData.specification,
          model: this.formData.model,
          primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
          customerTaxId: this.formData.customerTaxId,
          confirmTimeStart: this.formData.confirmTimeStart,
          confirmTimeEnd: this.formData.confirmTimeEnd,
          pageNo: this.pageInfo.pageNo,
          pageSize: this.pageInfo.pageSize,
          arrivalMethod: this.formData.arrivalMethod
        }
      )
        .then(res => {
          this.tableData = res.list
          this.total = res.total
          this.getConfirmedExpNumber()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.steelMillName,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.inDetailId) // id数组
        arry = Array.from(new Set(arry)) // 去重
        this.selectListId = arry.join(',') // 获取全部货物id
      })
    },
    handleClicktab (tab, event) {
      // this.getControlAuditLists()
    },
    chaxun () {
      this.JfgetConfirmedExpLists()
    },
    chongzhi () {
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.inWarehouseNo = ''
      this.formData.instockNo = ''
      this.formData.instockPlateNumber = ''
      this.formData.productType = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.confirmTimeStart = ''
      this.formData.confirmTimeEnd = ''
      this.formData.arrivalMethod = ''
      this.JfgetConfirmedExpLists()
      this.getVirtualBalingList()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockExpInfo/exportConfirmedExpList',
        { ...this.formData, instockStatus: '1' },
        '进仓记录信息表'
      )
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.JfgetConfirmedExpLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.JfgetConfirmedExpLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
      })
        .then((res) => {
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/yycJiLuChaXun')
    this.getRelationCustomerS()
    this.JfgetConfirmedExpLists()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 202 + 'px'
  }
}
</script>

<style>

</style>
